import { amountScale } from './currency.js';
/**
 * Shows a decimal money string with its currency (docs/DESIGN.md §5): "$1,284.69", "−$42.30"
 * (true minus sign), "1,500,000 LBP" (code after the number, never decimals for LBP).
 * Used by the web app and the server-side PDF. Intl.NumberFormat formats the decimal string
 * exactly; it never becomes a JS number.
 * `signed` adds "+" to positive amounts, for income in lists.
 */
export function formatAmount(amount, currency, locale, { signed = false } = {}) {
    const whole = amountScale(currency) === 0;
    const parts = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        // Currencies without a symbol of their own (LBP) read best as "1,500,000 LBP".
        currencyDisplay: currency === 'USD' ? 'symbol' : 'code',
        signDisplay: signed ? 'exceptZero' : 'auto',
        ...(whole ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
    }).formatToParts(amount);
    const sign = parts
        .filter((p) => p.type === 'minusSign' || p.type === 'plusSign')
        .map((p) => (p.type === 'minusSign' ? '\u2212' : '+'))
        .join('');
    const code = parts.find((p) => p.type === 'currency')?.value ?? currency;
    const number = parts
        .filter((p) => !['minusSign', 'plusSign', 'currency', 'literal'].includes(p.type))
        .map((p) => p.value)
        .join('');
    return currency === 'USD' ? `${sign}${code}${number}` : `${sign}${number} ${code}`;
}
//# sourceMappingURL=money-format.js.map